import { type AxiosError } from 'axios';

import { parseJSON } from '@/shared/helpers/parse-json';

export const getAxiosErrorMessage = (error: AxiosError<any>) => {
  if (error.response) {
    return error.response.data?.error.message ?? error.response.status;
  }

  if (error.request) {
    try {
      const parsedError = parseJSON<{ error?: { message: string } }>(
        error.request?.response
      );

      return parsedError?.error?.message ?? error.message;
    } catch {
      return error.message;
    }
  } else {
    return error.message;
  }
};
